module.exports = __webpack_public_path__ + "static/media/IMG_1590.51a7f236.JPG";